import React, { useEffect, useState } from "react";

import styles from "./ShowAndHide.module.css";

const ShowAndHide = ({
  children,
  headerText,
  headerComponent: Header,
  initiallyOpen,
  headerProps,
  headerComponentProps,
  containerProps,
  iconProps,
  entire = true,
  open: openProp,
}) => {
  const [open, setOpen] = useState(initiallyOpen);

  const handleOpenOrClose = () => {
    setOpen(!open);
  };

  useEffect(() => {
    if (openProp !== undefined) {
      setOpen(openProp);
    }
  }, [openProp]);

  return (
    <div
      {...containerProps}
      className={[
        styles.showAndHideContainer,
        containerProps && containerProps.className,
      ].join(" ")}
    >
      <div className={styles.clipWrapper}>
        <header
          {...headerProps}
          className={[
            styles.header,
            open ? styles.headerOpen : styles.headerClosed,
            headerProps && headerProps.className,
          ].join(" ")}
          onClick={entire ? handleOpenOrClose : () => {}}
          style={{ cursor: entire ? "pointer" : undefined }}
        >
          <div className={styles.headerContent}>
            {headerText || <Header {...headerComponentProps} />}
          </div>
          <button
            type="button"
            onClick={handleOpenOrClose}
            className={styles.controlButton}
          >
            <svg
              width={14}
              height={14}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2.4}
              className={[
                styles.icon,
                !open && styles.hidden,
                iconProps && iconProps.className,
              ].join(" ")}
              {...iconProps}
            >
              <path d="M18 15l-6-6-6 6" />
            </svg>
          </button>
        </header>
        <div
          className={[styles.childrenWrapper, !open && styles.hidden].join(
            " "
          )}
        >
          <div className={styles.children}>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default ShowAndHide;